module.exports = __webpack_public_path__ + "static/media/  (138).0fa0252b.jpg";